'use client';
import { useTranslation } from '@/i18n/LanguageProvider';

export default function TermsPage() {
  const { t } = useTranslation();
  return (
    <div>
      <section className="bg-gradient-to-br from-primary-600 to-secondary-600 text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl font-bold mb-4">{t('terms.title')}</h1>
          <p className="text-white/80">{t('terms.lastUpdated')}: {t('terms.date')}</p>
        </div>
      </section>
      <section className="py-16 bg-white dark:bg-gray-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-lg prose-gray max-w-none">
          <p className="text-gray-600 dark:text-gray-300 text-lg mb-8">{t('terms.intro')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s1Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('terms.s1Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s2Title')}</h2>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s2a','s2b','s2c','s2d'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s3Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('terms.s3Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s3a','s3b','s3c','s3d'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s4Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('terms.s4Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s4a','s4b','s4c','s4d'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s5Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300 mb-4">{t('terms.s5Intro')}</p>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s5a','s5b','s5c','s5d','s5e','s5f','s5g','s5h'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s6Title')}</h2>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s6a','s6b','s6c','s6d','s6e'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s7Title')}</h2>
          <ul className="list-disc pl-6 text-gray-600 dark:text-gray-300 space-y-2">
            {['s7a','s7b','s7c'].map(k=><li key={k}>{t(`terms.${k}`)}</li>)}
          </ul>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s8Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('terms.s8Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s9Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('terms.s9Text')}</p>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mt-12 mb-4">{t('terms.s10Title')}</h2>
          <p className="text-gray-600 dark:text-gray-300">{t('terms.s10Text')} <a href="mailto:hola@iterogo.com" className="text-primary hover:underline">hola@iterogo.com</a></p>
        </div>
      </section>
    </div>
  );
}
